import { FC } from 'react';
import * as S from './styles';

/** Enough to fill the grid on a wide screen; speakers repeat to cover it. */
const TILE_COUNT = 12;

/**
 * The session's own native speakers, tiled behind the screen's content. Tiles
 * are paused on an early frame rather than played, so this costs one metadata
 * load per tile and no simultaneous playback.
 */
export const SpeakerMosaic: FC<{ clips: string[] }> = ({ clips }) => {
  // Position is the identity here: a fixed decorative grid that cycles through
  // however many speakers the session happens to have.
  const tiles = clips.length
    ? Array.from({ length: TILE_COUNT }, (_, index) => ({
        key: `tile-${index}`,
        clip: clips[index % clips.length],
      }))
    : [];

  return (
    <>
      <S.Mosaic aria-hidden>
        {tiles.map(tile => (
          <S.Tile key={tile.key} data-testid="speakerMosaicTile">
            <S.TileVideo src={`${tile.clip}#t=0.5`} muted playsInline preload="metadata" />
          </S.Tile>
        ))}
      </S.Mosaic>
      {/* Kept even with no clips: an all-audio session has nothing to tile, and
          the wash is what it shows instead of the bare stage. */}
      <S.Tint aria-hidden data-testid="speakerMosaicTint" />
    </>
  );
};
